import { Button } from 'antd';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  border: none;
  padding: 0;
  margin: 0;
  outline: none;
  background: none;
  display: flex;
  cursor: pointer;
  box-shadow: none;

  &:hover,
  &:focus {
    background: none;
    box-shadow: none;
  }
`;

export function AppIconButton(props) {
  return <StyledButton type='text' {...props} />;
}
